import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
export var eventKey = 'signup-open_modal-click';
/**
 * Event to track clicks to all signup modal entry-points
 */ export function trackSignupOpenModalClick(SignUpType, PageURL2, SourceID3) {
    var Element4 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : '';
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            SignUpType: SignUpType,
            PageURL2: PageURL2,
            SourceID3: SourceID3,
            Element4: Element4
        }
    });
}
